// Decides whether a streamed feedback_delta should replace the preview on screen.
// Returns the new state, or null to ignore the payload.
//
// Server payloads are cumulative within an attempt, so length should only grow. If
// two feedback workers briefly overlap for the same chat (reload/multiple tabs), an
// older/shorter stream can arrive after a longer one; ignore it instead of morphing
// the UI backwards and making text look lost. When a provider fails mid-report, the
// server falls back and restarts the report under a higher attempt number, so the
// new attempt's shorter text replaces the old one rather than being ignored until it
// grows past it.
export function nextStreamState(state, htmlLength, attempt = 1) {
  if (attempt < state.attempt) return null
  if (attempt === state.attempt && htmlLength < state.length) return null

  return { attempt, length: htmlLength }
}
